import { render } from "./RemovalSetting.vue?vue&type=template&id=6164264c&scoped=true"
import script from "./RemovalSetting.vue?vue&type=script&lang=js"
export * from "./RemovalSetting.vue?vue&type=script&lang=js"

import "./RemovalSetting.vue?vue&type=style&index=0&id=6164264c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6164264c"]])

export default __exports__